/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'double_arrow': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#clip0_297_6201)" _fill="#0B2C62"><path pid="0" d="M0 16.337v-4.715l10.857-9.8a1.75 1.75 0 012.345 0L24 11.57v4.714L12.03 5.48 0 16.337z"/><path pid="1" d="M0 23.337v-4.715l10.857-9.799a1.75 1.75 0 012.345 0L24 18.569v4.714L12.03 12.48 0 23.337z"/></g><defs><clipPath id="clip0_297_6201"><path pid="2" _fill="#fff" transform="rotate(-90 12 12)" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
